import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import BaseLayout from '../layout/BaseLayout';
import Loading from '../components/Loading';
import ProtectedRoute from '../components/ProtectedRoute';
import AuthDebug from '../components/AuthDebug';


// Sitio
const Login = lazy(() => import('../views/Login'));
const Home = lazy(() => import('../views/Home'));
const OidcCallback = lazy(() => import('../views/OidcCallback'));

// Sesiones
const MisSesiones = lazy(() => import('../views/MisSesiones'));
const EncuestaSatisfaccion = lazy(() => import('../views/EncuestaSatisfaccion'));

// Administracion
const LoginAdmin = lazy(() => import('../views/Administracion/Login'));
const Perfil = lazy(() => import('../views/Administracion/Perfil'));
const Dashboard = lazy(() => import('../views/Administracion/Dashboard'));
const Reportes = lazy(() => import('../views/Administracion/Reportes'));
const Usuarios = lazy(() => import('../views/Administracion/Usuarios'));
const Expertos = lazy(() => import('../views/Administracion/Expertos'));
const ExpertosConvertir = lazy(() => import('../views/Administracion/Expertos/Convertir'));
const UsuariosCrear = lazy(() => import('../views/Administracion/Usuarios/Crear'));
const UsuariosActualizar = lazy(() => import('../views/Administracion/Usuarios/Actualizar'));
const UsuariosCargaMasiva = lazy(() => import('../views/Administracion/Usuarios/CargaMasiva'));
const UsuariosHorario = lazy(() => import('../views/Administracion/Usuarios/Horario'));
const MiHorario = lazy(() => import('../views/Experto/MiHorario'));

const SubdisciplinasView = lazy(() => import('../views/Foro/SubdisciplinasView'));
const ForoSubdisciplina = lazy(() => import('../views/Foro/ForoSubdisciplina'));
const ForoCrear = lazy(() => import('../views/Foro/Crear'));
const ForoAdministrador = lazy(() => import('../views/Administracion/Foros/AdminForos'));
const ForoDetalle = lazy(() => import('../views/Foro/ForoDetalle'));

const Perfiles = lazy(() => import('../views/Administracion/Perfiles'));
const PerfilesCrear = lazy(() => import('../views/Administracion/Perfiles/Crear'));
const PerfilesActualizar = lazy(() => import('../views/Administracion/Perfiles/Actualizar'));
const Logs = lazy(() => import('../views/Administracion/Logs'));

const Detalle = lazy(() => import('../views/Experto/Detalle'));

const ErrorPublica = lazy(() => import('../views/ErrorPublica'));

export default function App() {
	return (
		<>
			{/* <AuthDebug /> */}
			<Suspense fallback={<Loading />}>
				<Routes>
					<Route exact path='/' element={<Login />} />
					<Route exact path='*' element={<ErrorPublica />} />
					<Route exact path='/auth/callback' element={<OidcCallback />} />
					<Route exact path='/admin/login' element={<LoginAdmin />} />
					<Route element={
						<ProtectedRoute>
							<BaseLayout />
						</ProtectedRoute>
					}>
						<Route exact path='/home' element={<Home />} />
						<Route exact path='/mis-sesiones' element={<MisSesiones />} />
						<Route exact path='/encuesta-satisfaccion/:sessionId' element={<EncuestaSatisfaccion />} />
						<Route exact path="/experto/:id" element={<Detalle />} />
						<Route exact path="/foro/subdisciplinas" element={<SubdisciplinasView />} />
						<Route exact path="/foro/subdisciplina/:nombre" element={<ForoSubdisciplina />} />
						<Route exact path="/foro/crear/:nombre" element={<ForoCrear />} />
						<Route exact path="/foro/detalle/:foroId" element={<ForoDetalle />} />
						<Route exact path='/admin/foros' element={<ForoAdministrador />} />
						<Route exact path='/admin/dashboard' element={<Dashboard />} />
						<Route exact path='/admin/reportes' element={<Reportes />} />
						<Route exact path='/admin/configuracion' element={<Perfil />} />
						<Route exact path='/admin/usuarios' element={<Usuarios />} />
						<Route exact path='/admin/expertos' element={<Expertos />} />
						<Route exact path='/admin/expertos/convertir/:id' element={<ExpertosConvertir />} />
						<Route exact path='/admin/usuarios/crear' element={<UsuariosCrear />} />
						<Route exact path='/admin/usuarios/actualizar/:id' element={<UsuariosActualizar />} />
						<Route exact path='/admin/usuarios/horario/:id' element={<UsuariosHorario />} />
						<Route exact path='/admin/usuarios/carga-masiva' element={<UsuariosCargaMasiva />} />
						<Route exact path='/mi-horario' element={<MiHorario />} />
						<Route exact path='/admin/perfiles' element={<Perfiles />} />
						<Route exact path='/admin/perfiles/crear' element={<PerfilesCrear />} />
						<Route exact path='/admin/perfiles/actualizar/:id' element={<PerfilesActualizar />} />
						<Route exact path='/admin/dashboard/logs' element={<Logs />} />
					</Route>
				</Routes>
			</Suspense>
		</>
	);
}